import { useEffect, useState } from "react";

import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import { useAppDispatch, useAppSelector } from "@app/store";
import {
  setCategories,
  useDeleteCategoryMutation,
  useLazyGetCategoriesQuery,
} from "@modules/category";
import Table from '@mui/material/Table';
import { FilterParams } from "types";
import { PARAMS } from "@constants/index";
// eslint-disable-next-line no-restricted-imports
import { ICategory } from "@modules/category/types";

import { StyledBody, TitleWrapper, EachWrapper, Actions, Wrapper } from "./styled";

interface StateItems extends Omit<ICategory, 'id'> {
  id: number;
}

const Categories = () => {
  const categoryList = useAppSelector((state) => state.category.categories);

  const [state, setState] = useState<StateItems[]>([]);
  const dispatch = useAppDispatch();
  const [getCategories] = useLazyGetCategoriesQuery()
  const [deleteCategory] = useDeleteCategoryMutation()

  const [filters, setFilters] = useState<FilterParams>({
    limit: PARAMS.LIMIT,
    offset: PARAMS.OFFSET,
  })

  const handleGetRequest = async () => {
    try {
      const responseCategories = await getCategories(filters).unwrap();

      dispatch(setCategories(responseCategories.certificateCategory));
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteCategory = async (id?: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteCategory({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <Link to={PRIVATE_PAGES.CREATE_CATEGORY}>
        <Button variant="contained" color="primary">
          Create Category
        </Button>
      </Link>

      <Wrapper>
        <Table>
          <TitleWrapper>
            <div>TITLE AM</div>
            <div>TITLE En</div>
            <div>TITLE Ru</div>
            <div>ACTIONS</div>
          </TitleWrapper>
          <StyledBody>
            {categoryList?.map((category) => {
              return (
                <EachWrapper key={category.id}>
                  <div>{category.titleAm}</div>
                  <div>{category.titleEn}</div>
                  <div>{category.titleRu}</div>
                  <Actions>
                    <Link to={`/update-category/${category?.id}`}>
                      <Button
                        variant="outlined"
                      >
                        Edit
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      onClick={() => handleDeleteCategory(category?.id)}
                    >
                      Delete
                    </Button>
                  </Actions>
                </EachWrapper>
              )
            })}
          </StyledBody>
        </Table>
      </Wrapper>
    </Box>
  )
};

export default Categories;
